module.exports = __webpack_public_path__ + "static/media/Oleksander.7fb96969.jpg";